module.exports = __webpack_public_path__ + "img/choose-up-Up Social Lugoj-disabled.f62e6853.png";